// Load Events
$(document).ready(
    function() {
        Fundu.Utils.Loader.init();
    }
);
